export enum FilterType {
  MULTI_SELECT,
  RANGE
}
